import styled from 'styled-components';

export const HighlightSpan = styled.span`
  .hlt1 {
    font-weight: bold;
  }
`;
